export default "__VITE_ASSET__11be703a__"